<template>
	<span class="nowrap" :style="sty" @click="$emit('click', $event)">
		<slot></slot>
	</span>
</template>
<script>
export default {
	props: {
		value: {type: Number, required: true},
		color: {type: String, default: "#4caf50"},
		bgColor: {type: String, default: "#9e9e9e"},
		textColor: {type: String, default: "#fff"},
		width: {type: [Number, String]},
		height: {type: [Number, String]},
		radius: {type: [Number, String]},
	},
	computed: {
		sty() {
			// console.log("this.value * 100=", this.value * 100);
			// console.log("progress", this.value);
			return {
				background: `${this.bgColor} linear-gradient(${this.color},${this.color}) no-repeat`,
				backgroundSize: `${this.value * 100}% 100%`,
				color: this.textColor,
				width: this.width,
				height: this.height,
				"border-radius": this.radius,
			};
		},
	},
};
</script>
